document.addEventListener('DOMContentLoaded', () => {

  document.addEventListener('click', (e) => {

    const label = e.target.closest('.atc-vaiant-item label');
    if (!label) return;

    const item = label.closest('.atc-vaiant-item');
    const input = item.querySelector('input[type="radio"]');
    const form = item.closest('form');

    form.parentElement.querySelector('.size-error')?.remove();

    if (item.classList.contains('active')) {
      item.classList.remove('active');
      input.checked = false;
      return;
    }

    form.querySelectorAll('.atc-vaiant-item').forEach(el => {
      el.classList.remove('active');
    });

    input.checked = true;
    item.classList.add('active');

  });

  document.addEventListener('click', async (e) => {

    const btn = e.target.closest('.atc-btn');
    if (!btn) return;

    const container = btn.closest('.atc-variant-container');
    const form = container.querySelector('.ot-qatc-form');

    const selectedVariant = form.querySelector('input[name="id"]:checked');

    container.querySelector('.size-error')?.remove();

    if (!selectedVariant) {
      const error = document.createElement('div');
      error.className = 'size-error';
      error.textContent = 'Please select a size';
      form.insertAdjacentElement('afterend', error);
      setTimeout(() => {error.remove();}, 1000);

      return;
    }

    const quantityInput = container.querySelector('.quantity__input');
    const quantity = parseInt(quantityInput?.value || 1);
    const cartDrawer = document.querySelector('cart-drawer');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: selectedVariant.value,
          quantity,
          sections: cartDrawer ? cartDrawer.getSectionsToRender().map(section => section.id) : [],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      if (data.status) { throw new Error(data.description); }
      if (quantityInput) { quantityInput.value = 1; }

      form.querySelectorAll('.atc-vaiant-item').forEach(item => { item.classList.remove('active'); });
      form.querySelectorAll('input[name="id"]').forEach(input => { input.checked = false; });

      if (cartDrawer) {

        cartDrawer.renderContents(data);

        if (cartDrawer.classList.contains('is-empty')) { cartDrawer.classList.remove('is-empty'); }
        if (typeof cartDrawer.open === 'function') { cartDrawer.open(); }
      }

    } catch (error) {
      console.error('ATC Error:', error);
    }

  });

  document.addEventListener('click', (e) => {
    if (
      !e.target.closest('.card__information_right') &&
      !e.target.closest('.atc-container')
    ) {
      document.querySelectorAll('.atc-container.active').forEach(el => {
        el.classList.remove('active');
      });
    }
    const trigger = e.target.closest('.card__information_right');
    if (!trigger) return;

    const card = trigger.closest('.card-wrapper');
    const atcContainer = card?.querySelector('.atc-container');

    document.querySelectorAll('.atc-container.active').forEach(el => {
      if (el !== atcContainer) { el.classList.remove('active'); }
    });

    atcContainer?.classList.add('active');

  });

  // document.querySelectorAll('.card-wrapper').forEach(card => {
  //   card.addEventListener('mouseleave', () => { card.querySelector('.atc-container')?.classList.remove('active'); });
  // });

  

  function initCardSwatches() {
    const swatches = document.querySelectorAll('.product-swatches__item');

    swatches.forEach(swatch => {
      if (swatch.dataset.swatchInit === 'true') return;
      swatch.dataset.swatchInit = 'true';

      swatch.addEventListener('click', event => {
        const colorSwatch = event.currentTarget;
        const card = colorSwatch.closest('.card-wrapper');
        if (!card) return;

        card.querySelectorAll('.product-swatches__item.active')
            .forEach(active => active.classList.remove('active'));
        colorSwatch.classList.add('active');

        card.querySelectorAll('.ot-qatc-form .atc-vaiant-item.active-swatch')
            .forEach(active => active.classList.remove('active-swatch'));

        const color = colorSwatch.dataset.cardColor;
        if (color) {
          card.querySelectorAll(`.ot-qatc-form .atc-vaiant-item[data-card-color="${color}"]`).forEach(size => size.classList.add('active-swatch'));
        }

        const imgEl = card.querySelector('.card__media img');
        if (!imgEl) return;

        if (!card.dataset.originalImage) {
          card.dataset.originalImage = imgEl.src;
          card.dataset.originalSrcset = imgEl.srcset || '';
        }

        const imgElHover = card.querySelectorAll('.card__media img')[1];

        if (imgElHover && !card.dataset.originalImageHover) {
          card.dataset.originalHoverImage = imgElHover.src;
          card.dataset.originalHoverSrcset = imgElHover.srcset || '';
        }

        const variantImage = colorSwatch.dataset.variantImage;

        const variantHoverImage = colorSwatch.dataset.variantNextImage;

        if (variantImage) {
          imgEl.src = variantImage;
          imgEl.srcset = `${variantImage} 165w, ${variantImage} 360w, ${variantImage} 533w, ${variantImage} 720w, ${variantImage} 940w, ${variantImage} 1066w, ${variantImage} 1920w`;
          imgEl.alt = color || 'Variant Image';
        } else {
          imgEl.src = card.dataset.originalImage;
          imgEl.srcset = card.dataset.originalSrcset;
        }

        if ( variantHoverImage) {
          imgElHover.src = variantHoverImage;
          imgElHover.srcset = `${variantHoverImage} 165w, ${variantHoverImage} 360w, ${variantHoverImage} 533w, ${variantHoverImage} 720w, ${variantHoverImage} 940w, ${variantHoverImage} 1066w, ${variantHoverImage} 1920w`;
          imgElHover.alt = color || 'Variant Image';
        } else {
          imgElHover.src = card.dataset.originalHoverImage;
          imgElHover.srcset = card.dataset.originalHoverSrcset;
        }

        const variantURL = colorSwatch.dataset.variantUrl;

        if (variantURL) {
          card.querySelectorAll('a').forEach( a => {
            a.href = variantURL;
          });
          
        }
      });
    });
  }

  initCardSwatches();

});

document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector("slider-component");
  if (!slider) return;

  const nextButton = slider.querySelector(".slider-button--next");
  if (!nextButton) return;

  const INTERVAL = 3000;

  let autoplay = setInterval(() => {
   // nextButton.click();
  }, INTERVAL);

  slider.addEventListener("mouseenter", () => clearInterval(autoplay));

  slider.addEventListener("mouseleave", () => {
    autoplay = setInterval(() => {
     // nextButton.click();
    }, INTERVAL);
  });
});

      document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.product-card-wrapper').forEach(productItem => {
          const swiperEl = productItem.querySelector('.mySwiper-g');
          if (!swiperEl) return;

          const swiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true
          });

          const defaultSlide = swiperEl.querySelector('.swiper-slide[data-default="true"]');
          const sliderCard = defaultSlide?.closest('.product-card-wrapper')
          if (defaultSlide && sliderCard) {
            const nextImage = sliderCard.querySelector('.product-swatches .product-swatches__item ').dataset.variantNextImage;
            if (nextImage && !defaultSlide.querySelector('.variant-next-image')) {
              const img = document.createElement('img');

              img.src = nextImage;
              img.srcset = `
                ${nextImage} 165w,
                ${nextImage} 360w,
                ${nextImage} 533w,
                ${nextImage} 720w,
                ${nextImage} 800w
              `;
              img.sizes =
                '(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';
              img.loading = 'lazy';
              img.width = 800;
              img.height = 1200;
              img.alt = '';
              img.className = 'motion-reduce variant-next-image';

              const media =
                defaultSlide.querySelector('.media') ||
                defaultSlide.querySelector('.card__media') ||
                defaultSlide;

              media.appendChild(img);
            }

            const allSlides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
            const index = allSlides.indexOf(defaultSlide);
            if (index !== -1) swiper.slideTo(index);
          }
        });
      });
      document.querySelectorAll('.product-swatches__item').forEach((radio) => {
        radio.addEventListener('click', function () {
          const selectedImageId = this.dataset.imageId;
            const nextImage = this.dataset.variantNextImage;

          const productItem = this.closest('.product-card-wrapper');
          const swiperEl = productItem.querySelector('.mySwiper-g');
          const swiperInstance = swiperEl?.swiper;

          if (!swiperInstance) return;

          const slides = swiperEl.querySelectorAll('.swiper-slide');
          slides.forEach((slide, index) => {
            if (slide.dataset.imageId === selectedImageId) {
              if (nextImage) {
                const img = document.createElement('img');
                img.src = nextImage;
                img.srcset = `
                  ${nextImage} 165w,
                  ${nextImage} 360w,
                  ${nextImage} 533w,
                  ${nextImage} 720w,
                  ${nextImage} 800w
                `;
                img.sizes =
                  '(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';
                img.loading = 'lazy';
                img.width = 800;
                img.height = 1200;
                img.alt = '';
                img.className = 'motion-reduce variant-next-image';


                slide.appendChild(img);
              }

              swiperInstance.slideTo(index);
            }
          });
        });
      })